import React from "react";

const AccordionWrapper = (props) => {
  return (
    <div className="accordionWrapper">
      <div className="accordion">{props.children}</div>
    </div>
  );
};

export default AccordionWrapper;
